import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardDocsComponent } from './dashboard-docs/dashboard-docs.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard/Dashboard',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
      hasSideNav: false
    }
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    data: {
      title: 'Build-In Notifications'
    }
  },
  {
    path: 'dashboard',
    redirectTo: '/dashboard/Dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard/docs',
    component: DashboardDocsComponent,
    data: {
      title: 'Coiled Tubing Analytics',
      showHeader: true
    }
  },
  {
    path: 'dashboard/:page',
    component: DashboardComponent,
    data: {
      title: 'Coiled Tubing Analytics',
      showHeader: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
